/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { solutionDescriptionDtoSchema } from "./solutionDescriptionDtoSchema.ts";
import { solutionProcessStepDtoSchema } from "./solutionProcessStepDtoSchema.ts";
import { solutionValueDriverDtoSchema } from "./solutionValueDriverDtoSchema.ts";
import { z } from "zod/v4";

export const solutionSectionDtoSchema = z.object({
  get description() {
    return solutionDescriptionDtoSchema.optional();
  },
  get steps() {
    return z.array(solutionProcessStepDtoSchema).optional();
  },
  get valueDrivers() {
    return z.array(solutionValueDriverDtoSchema).optional();
  },
});
